
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { createUser } from "../redux/user/slice";
import { createAgent } from "../redux/agent/slice";


export default function Private({ children }) {

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    const dispatch = useDispatch();

    if(user === null) {
        
        if(sessionStorage.getItem('id') === null) {
            
            return <Navigate to="/login"></Navigate>

        } else {

            const id = JSON.parse(sessionStorage.getItem('id'));
            const empresa = JSON.parse(sessionStorage.getItem('empresa'));
            const nome = JSON.parse(sessionStorage.getItem('nome'));
            const email = JSON.parse(sessionStorage.getItem('email'));

            dispatch(createUser({
                id: id,
                empresa: empresa,
                nome: nome,
                email: email,
            }))

            if(agent === null) {

                const agente_id = JSON.parse(sessionStorage.getItem('agente_id'));
                const agente = JSON.parse(sessionStorage.getItem('agente'));
                const plano = JSON.parse(sessionStorage.getItem('plano'));
                const status = JSON.parse(sessionStorage.getItem('status'));

                dispatch(createAgent({
                    id: agente_id,
                    nome: agente,
                    plano: plano,
                    status: status,
                }))
            
            }

        }

    }

    return children;
    
}